module.exports = __webpack_public_path__ + "static/media/Fotos_Entrega_Cestas_Poção_1.db3cc45d.jpeg";